const view = /*html*/`
<!--begin::Container-->
<div id="kt_content_container" class="container-xxl">
    <div class="row row-cols-1 row-cols-md-2 g-4">
        <div class="col">
            <div class="card card-stretch card-flush w-100 bgi-position-x-end bgi-position-y-center px-20 py-10 custom-disabled" data-navigo href="play/solo" style="background: url('assets/media/logos/btn-ak.png')">
                <div class="d-flex align-items-center">
                    <div class="card-title">
                        <h1 class="fs-2hx text-white teko-header" data-i18n="">Solo Ranked</h1>
                        <p class="text-gray-700 fs-6" data-i18n="">Competitivo rankeado 5vs5 solo para jugadores individuales</p>
                    </div>
                </div>            
            </div>
        </div>
        <div class="col">
            <div class="card card-stretch card-flush w-100 bgi-position-x-end bgi-position-y-center px-20 py-10 custom-disabled cursor-not-allowed" style="background: url('assets/media/logos/btn-m4.png')">
                <div class="d-flex align-items-center">
                    <div class="card-title">
                        <h1 class="fs-2hx text-white teko-header" data-i18n="">Ranked</h1>
                        <p class="text-gray-700 fs-6" data-i18n="">Competitivo rankeado 5vs5 solo o con amigos</p>
                    </div>
                </div>            
            </div>
        </div>
    </div>

    <div class="row row-cols-1 row-cols-md-3 g-4">
        <div class="col">
            <div class="card card-stretch card-flush w-100 bgi-position-x-end bgi-position-y-center px-20 py-10 custom-disabled cursor-not-allowed" style="background: url('assets/media/logos/btn-awp.png')">
                <div class="d-flex align-items-center">
                    <div class="card-title">
                        <h1 class="fs-1 text-white teko-header" data-i18n="">Custom Matches</h1>
                        <p class="text-gray-700 fs-6" data-i18n="">Partidas personalizadas, juega con tus reglas</p>
                    </div>
                </div>            
            </div>
        </div>
        <div class="col">
            <div class="card card-stretch card-flush w-100 bgi-position-x-end bgi-position-y-center px-20 py-10 cursor-pointer" data-navigo href="play/pug" style="background: url('assets/media/logos/btn-usp.png')">
                <div class="d-flex align-items-center">
                    <div class="card-title">
                        <h1 class="fs-1 text-white teko-header" data-i18n="">PUG (Pick Up Game)</h1>
                        <p class="text-gray-700 fs-6" data-i18n="">Competitivo clásico en servidores públicos</p>
                    </div>
                </div>            
            </div>
        </div>
        <div class="col">
            <div class="card card-stretch card-flush w-100 bgi-position-x-end bgi-position-y-center px-20 py-10 cursor-pointer" data-navigo href="play/training" style="background: url('assets/media/logos/btn-glock.png')">
                <div class="d-flex align-items-center">
                    <div class="card-title">
                        <h1 class="fs-1 text-white teko-header" data-i18n="">Training</h1>
                        <p class="text-gray-700 fs-6" data-i18n="">Servidores AIM, DeathMatch, Wallbang</p>
                    </div>
                </div>            
            </div>
        </div>
    </div>

</div>`;

export default view;